import React from 'react';
import { Link } from 'react-router-dom';

const NavbarButtons = ({ currentUser }) => {

  return (
    <React.Fragment>
      <ul className="buy-button list-inline mb-0">
        {
          currentUser ?
            <>
              <li className="list-inline-item btn-icon button mb-0 ps-1 d-none d-sm-inline-block">
                <Link
                  to="/blog"
                  className="btn btn-md btn-primary btn-primary"
                >
                  Blogs
                </Link>
              </li>
              <li className="list-inline-item btn-icon button mb-0 ps-1">
                <Link
                  to="/tutorials"
                  className="btn btn-md btn-primary btn-primary"
                >
                  <span className="nav-new-star" aria-label="New">★</span>
                  Tutorials
                </Link>
              </li>
              <li className="list-inline-item btn-icon button mb-0 ps-1">
                <Link
                  to="/vocabularies"
                  className="btn btn-md btn-primary btn-primary"
                >
                  Dashboard
                </Link>
              </li>
            </>
            :
            <>
              <li className="list-inline-item btn-icon button mb-0 ps-1">
                <Link
                  to="/tutorials"
                  className="btn btn-md btn-primary btn-light"
                >
                  <span className="nav-new-star" aria-label="New">★</span>
                  Tutorials
                </Link>
              </li>
              <li className="list-inline-item btn-icon button mb-0 ps-1">
                <Link
                  to="/login"
                  className="btn btn-md btn-primary btn-light"
                >
                  Log In
                </Link>
              </li>
            </>
        }

      </ul>
    </React.Fragment>
  );
};

export default NavbarButtons;
